import React, { useEffect, useState } from 'react'
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import * as bie from "react-bootstrap";
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import { failureAlert } from '../../CommonUtils/SweetAlerts';
import Swal from 'sweetalert2';
import { FaEdit } from "react-icons/fa";

export default function GrantEditFfcaFeedback() {
    const [showFeedbackDetails, setFeedbackDetails] = useState([])
    const Columns = [
        { Header: "Sl.No", accessor: (row, index) => index + 1, },
        {
            Header: "College Code", accessor: "coll_code",
        },
        {
            Header: "College Name", accessor: "inst_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.inst_name}</div>
            ),
        },
        {
            Header: "Feedback", accessor: "recmnd_optn",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.recmnd_optn || "-"}</div>
            ),
        },
        {
            Header: "Date of Inspection", accessor: "date_of_insp",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.date_of_insp || "-"}</div>
            ),
        },
        {
            Header: 'Action',
            accessor: (cell) => {
                return <>
                    <button type='button' className="btn btn-primary btn-sm" onClick={() => {
                        SaveGrantEdit(cell?.coll_code, cell?.inst_name)
                    }}>  <FaEdit size={20} /> &nbsp; Grant Edit</button>
                </>;
            },
        },

    ]
    function SaveGrantEdit(collcode, collgename) {

        Swal.fire({
            html: `You are about to revert changes for <span style="color: blue;">${collgename}</span>, with College Code <span style="color: red;">${collcode}</span> . This action cannot be undone. Do you wish to proceed?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            backdrop: false,
        }).then((result) => {
            if (result.isConfirmed) {
                let url = config.url.API_URL + `updateffcsfdbkdtls/` + collcode;
                CommonAxiosPost(url).then((res) => {
                    if (res?.data?.scode === "01") {
                        Swal.fire({
                            text: res?.data?.sdesc,
                            icon: "success",
                            backdrop: true
                        }).then(() => {
                            GetFFCAFeedbackDetails()
                        });
                    } else {
                        failureAlert("Something went wrong,Please check");
                    }
                })
            }
        });
    }

    function GetFFCAFeedbackDetails() {
        let url = config.url.API_URL + `getffcafdbkeditdtls`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setFeedbackDetails(res?.data?.data)
            }
            else {
                setFeedbackDetails([])
            }
        })
    }

    useEffect(() => {
        GetFFCAFeedbackDetails()
    }, [])



    return (
        <div>
            <div className='affl-newdiv'>
                <bie.Container fluid className="px-1" >
                    <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100">
                        <div className="inner-herbpage-service-title-sub pt-0"  >
                            <h1>Grant Edit for Final Submission/ Feedback</h1>
                        </div>
                        {showFeedbackDetails.length > 0 ? (<>
                            <bie.Row className="my-3 px-3">
                                <div className="table-responsive">
                                    <CommonReactTable data={showFeedbackDetails} columns={Columns} filename="Grant Edit for Final Submission/ Feedback"
                                        headerName={`Grant Edit for Final Submission/ Feedback`} />
                                </div>
                            </bie.Row>
                        </>) : (<center center className='text-danger h5 pt-5'>***** No Data Found *****</center>)}
                    </bie.Container>
                </bie.Container>
            </div>
        </div>
    )
}
